<template>
    <div>
      <el-row>
        <el-col :span="17">
          <!-- 面包屑导航区域-->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
            <el-breadcrumb-item>Quality(beta)</el-breadcrumb-item>
            <el-breadcrumb-item>Quality Category</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-card>
        <div>
          <el-tabs :tab-position="value1" style="margin-bottom: 30px;" @tab-click="handleClick">
            <br>
            <el-tab-pane label="QA Category">
              <el-table :data="list" border stripe style="width: 100%">
                <el-table-column
                  prop="id"
                  label="Id"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="parts"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="type"
                  label="type"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="Status"
                  width="180">
                </el-table-column>
<!--                <el-table-column-->
<!--                  prop="std"-->
<!--                  label="STD 标准值"-->
<!--                  width="150">-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                  prop="ucl"-->
<!--                  label="UCL 上限值"-->
<!--                  width="150">-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                  prop="version"-->
<!--                  label="Version"-->
<!--                  width="150">-->
<!--                </el-table-column>-->

                <el-table-column label="Operation" width="350">
                  <template slot-scope="index">
                    <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
                    <el-button type="info" plain size="mini" @click="getCategory(index)">Category</el-button>
                    <!--              <el-button type="info" plain size="mini" @click="getPermissions(index)">Followers</el-button>-->
<!--                    <el-button type="info" plain size="mini" @click="edit(index)">Edit</el-button>-->
                    <!--          <el-button type="info" plain size="mini" @click="del(props.row.code)">Delete</el-button>-->
                  </template>
                </el-table-column>

              </el-table>

            </el-tab-pane>
<!--            -->
            <el-tab-pane label="QC Category">QC Category</el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
      <el-dialog :title="title"
                 width="50%" :visible.sync="dialogFormVisible" >
        <el-table :data="list2" border stripe style="width: 100%">
          <el-table-column
            prop="id"
            label="Id"
            width="80">
          </el-table-column>
          <el-table-column
            prop="type"
            label="Type"
            width="80">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Category"
            width="150">
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            width="150">
          </el-table-column>
<!--          <el-table-column label="Operation" width="350">-->
<!--            <template slot-scope="index">-->
<!--              <el-button type="info" plain size="mini" @click="goTestCategory(index)">Define Test Category</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'QualityCategory',
  data () {
    return {
      title: '',
      list2: [],
      dialogFormVisible: false,
      list: [],
      // list: [
      //   { id: '1', part: 'cap', version: '1.0', type: 'qa' },
      //   { id: '2', part: 'collar', version: '1.0', type: 'qa' },
      //   { id: '3', part: 'shoulder', version: '1.0', type: 'qa' }
      // ],
      value1: 'QA Category',
      value: '',
      options: [{
        value: '1.0'
      }, {
        value: '2.0'
      }]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    goTestCategory (x) {
      console.log(x)
    },
    async getCategory (x) {
      console.log(x.row)
      this.title = x.row.name
      this.dialogFormVisible = true
      const { data: res } = await this.$http.get('/qualityCategories/getQualityCategoriesList', { params: { page: 1, size: 100, type: 'qa', parentId: x.row.id } })
      this.list2 = res.records
    },
    handleClick (tab, event) {
      console.log(tab.label)
    },
    async getList () {
      const { data: res } = await this.$http.get('/qualityCategories/getQualityCategoriesList', { params: { page: 1, size: 100, type: 'qa', level: 1 } })
      this.list = res.records
      this.total = res.total
    }
  }
}
</script>

<style scoped>

</style>
